import { Record } from "immutable";

export type ModuleId = string;
export type ContentId = string;

export type ContentModuleType<Content> = {
  id: ModuleId | undefined;
  skill: string | undefined;
  parentId: ContentId | undefined;
  moduleType: string;
  content: Content;
  moduleDifficulty: number | null;
  textToSpeechDisabled: boolean | undefined;
};

export type OptionalContentModuleType<Content> = Partial<
  ContentModuleType<Content>
>;

const defaultModule: ContentModuleType<any> = {
  id: undefined,
  skill: undefined,
  parentId: undefined,
  moduleType: "unknown",
  content: null,
  moduleDifficulty: null,
  textToSpeechDisabled: undefined
};

export default class ContentModule extends Record(defaultModule) {}
